/**
 * Default configuration values
 * Replaces static .env file with runtime defaults
 */

import type { AppConfig } from './types';

/**
 * Default configuration object
 * Used as fallback when /config endpoint fails
 */
export const DEFAULT_CONFIG: AppConfig = {
  // API Configuration
  API_BASE_URL: 'http://localhost:3001/api',
};

/**
 * Configuration endpoint
 */
export const CONFIG_ENDPOINT = '/siteconfig/siteconfig.json';

/**
 * Configuration loading timeout (milliseconds)
 */
export const CONFIG_TIMEOUT = 5000;

/**
 * Number of retry attempts for config loading
 */
export const CONFIG_RETRY_ATTEMPTS = 3;

/**
 * Delay between retry attempts (milliseconds)
 */
export const CONFIG_RETRY_DELAY = 1000;
